import React from 'react';

import { Button as AntdButton } from 'antd';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';
import { SupervisionUserEventsFilterFormValues } from 'components/Supervision/SupervisionHeader/types';

import './FormFooter.less';

interface FormActionProps {
  setFilter: (value: Partial<SupervisionUserEventsFilterFormValues>) => void;
}

export function FormAction({ setFilter }: FormActionProps): React.ReactElement {
  const context = useBaseFormContext<SupervisionUserEventsFilterFormValues>();

  function resetFilter() {
    context.setFieldsValue({
      dateRangeRealisation: undefined,
      operations: undefined,
      profils: undefined,
    });
  }

  return (
    <div className={'form-footer-container'}>
      <AntdButton onClick={resetFilter}>Réinitialiser</AntdButton>

      <AntdButton
        type="primary"
        onClick={() => setFilter(context.getFieldsValue())}
      >
        Rechercher
      </AntdButton>
    </div>
  );
}

export default FormAction;
